$(function () {

    $(document).on("click", ".by-letter", function () {
        event.preventDefault();     
        $(".by-letter").removeClass("active")
        $(this).addClass("active")  
        refrehTravelerList();
    })

    $(document).on("keyup", ".txtTravelerSearch", function () {

        refrehTravelerList();        
    })

    $(document).on("click", ".activitylist_loadmore", function () {
        event.preventDefault();   
        refrehActivityList(true)
    })

    $(document).on("click", ".activity-plan-table th", function () {
        event.preventDefault();

        var current = traveler_activity_current_sort();

        var sNewSort = $(this).data("sort");
        var sNewOrder = "D";
        if (sNewSort == current.data("sort")) {
            //toggle
            sNewOrder = (current.hasClass("sorting_desc") ? "sorting_asc" : "sorting_desc")
        }
        else {
            sNewOrder = (sNewSort == "NAME" || sNewSort == "TYPE" ? "sorting_asc" : "sorting_desc")
        }

        //remove all old ones
        $(".activity-plan-table th").removeClass("sorting_asc").removeClass("sorting_desc");

        $(this).addClass(sNewOrder);

        refrehActivityList(false);
    })

    $(document).on("click", ".show-activity", function (event) {
        event.preventDefault();
        showModal({ url: "/widgets/Traveler/Track.aspx?m=1&eid=" + $(this).data("recip-id"), showSave: false, title: "Track Activity" });

    })

    $(document).on("click", ".resend-email", function (event) {
        event.preventDefault();
    
        if (!confirm("Are you sure you want to resend the trip to traveler '" + $(this).data("recip-traveler")  + "'?")) { return; }


        Page_Blur(true)
        var req = new Object;
        req.ReportID = $(this).data("recip-id"); //hijack this field to pass the email id
        req.PlaceKey ="";
        req.PlaceType ="";
        req.PlaceID ="";
        req.ClientIDs ="";
        req.Subject ="";
        req.Message ="";
        req.CopyUser = false;

        var DTO = { 'Req': req }          

        DynaProxy.invoke("ResendEmail", DTO, function (data) {  
            Page_Blur(false)
            var s=data;
            if (s.indexOf("-")==0){
                s=s.replace("-3","") ;
                if (s.length>2){
                    showSupportNotification(s); 
                }else{
                    showSupportNotification('Unable to re-send trip.');  
                }
            }
            else{  //success
                refrehActivityList(false);
                showSystemNotification(data);
            }
        }, function (data) {
            Page_Blur(false)
            showSupportNotification('Unable to re-send trip.');  
        })



     

    })
})


function refrehTravelerList() {

    if ($(".travelerlist").length==0){ return ;}

    element_Blur(".travelerlist", true);

    var val=$(".txtTravelerSearch").val()

    //ignore value search when less then 3 chars
    if (val.length < 3) {val= ""; }  
        
    if (val==""){ $(".jq-traveler-letters").show();}else{ $(".jq-traveler-letters").hide();}
         
    var req = new Object; 
    req.StartsWith = $(".jq-traveler-letters").find(".active").data("letter");; 
    req.Value = val;

    var DTO = { 'Req': req }
    DynaProxy.invoke("GetTravelers", DTO, function (data) {  
        $(".travelerlist").html(data);
        init_traveler_trav_cards();
        element_Blur(".travelerlist", false);
    }, function (data) {
        showSupportNotification('Unable to get travelers.');
        element_Blur(".travelerlist", false);
    })
}



function refrehActivityList(loadmore) {

    element_Blur("#activity-list", true)
   
    var current = traveler_activity_current_sort();
    var clientid = $(".activity-plan-table").data("client-id");
    var reportid = $(".activity-plan-table").data("report-id");
    var pg = 1;
    if (loadmore) { pg = $(".activitylist_loadmore").data("page"); }

    var req = {       
        Sort: current.data("sort"),
        SortOrder: (current.hasClass("sorting_asc") ? "A" : "D"),
        Page: pg,
     
    };
    
    var DTO = { 'Req': req, 'TravelerId': clientid, 'ReportId':reportid };
    DynaProxy.invoke("GetActivityList", DTO, function (data) {
        $("#activity-list").find("tr.load-more").remove();
        if (loadmore) { $("#activity-list").find("tbody").append(data); }
        else { $("#activity-list").find("tbody").html(data); }
        element_Blur("#activity-list", false)
        init_trip_trav_cards();

    }, function (data) {
        showSupportNotification('Unable to get Trip Plan.');
        element_Blur("#activity-list", false)
    });
    return false;
}

function traveler_activity_current_sort() {
    var e = $(".activity-plan-table th.sorting_asc");
    if (e.length == 0) { e = $(".activity-plan-table th.sorting_desc") }
    return e;
}